<template>
  <div class="libox">
    <a :href="'/Detail?contentId='+list.CONTENT_ID" target="_blank" class="phoneShow" />
    <div class="rightBox">
      <span class="titles111">
        <span v-if="list.CONTENT_IS_TOP === '1'" class="zhiding">置顶</span>
        <a class="title" :href="'/Detail?contentId='+list.CONTENT_ID" target="_blank">{{ list.CONTENT_TITLE }}</a>
      </span>
      <p v-if="list.CONTENT_ABSTRACT" class="contentbox">
        {{ list.CONTENT_ABSTRACT }}
      </p>
      <p v-else class="contentbox_no">
        <!--暂无摘要-->
      </p>
      <div class="foot_content">
        <span v-if="isdoc===true" class="types">文库</span><span v-else class="types">资讯</span>
        <!--<span class="column" @click="gocolumn(list.COLUMN_ID,list.COLUMN_NAME)">{{ list.COLUMN_NAME }}</span>-->
        <span class="times">{{ list.CONTENT_ISSUE_DATE|changeTime }}</span>
        <span class="readSize el-icon-view">   {{ list.CONTENT_READING_SIZE }}</span>
        <span class="collectionSize el-icon-star-on " @click="goshowcang(list.CONTENT_ID)">   {{ currentData.CONTENT_COLLECTION_SIZE }}</span>
        <span class="speckSize" @click="gopinglun"><svg-icon icon-class="pinlun" />  {{ list.CONTENT_SPEAK_SIZE }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// ///首页列表模板上中下形式
import { addCollect } from '@/api/api.js'

export default {
  name: 'ListTemolate1',
  props: ['list', 'index', 'isdoc'],
  data() {
    return {
      randomimg: Math.floor(Math.random() * 5),
      defaultimg: [
        require('@/static/newsdefault1.jpg'),
        require('@/static/newsdefault2.jpg'),
        require('@/static/newsdefault3.jpg'),
        require('@/static/newsdefault4.jpg'),
        require('@/static/newsdefault5.jpg')
      ],
      currentData: {}
    }
  },
  created() {
    this.currentData = this.list
    // console.log(this.currentData)
  },
  methods: {
    gocolumn: function(contentId, name) {
      window.location.href = '/column/?columnId=' + contentId
    },
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    },
    gopinglun: function() {
      if (this.getLoca('userid')) {

      } else {
        this.$router.push({ path: '/login' })
      }
    },
    goshowcang: function() {
      if (this.getLoca('userid')) {
        var obj = {}
        obj.userId = this.getLoca('userid')
        obj.contentId = this.$route.query.contentId
        addCollect(obj).then(res => {
          if (res.data === true) {
            if (this.list.collectionNOrNot) {
              this.$message({
                message: '取消收藏成功',
                type: 'success'
              })
              this.list.cmsCollectionNumber = this.list.cmsCollectionNumber - 1
            } else {
              this.$message({
                message: '收藏成功',
                type: 'success'
              })
              this.list.cmsCollectionNumber = this.list.cmsCollectionNumber * 1 + 1
            }
            this.list.collectionNOrNot = !this.list.collectionNOrNot
          }
        })
      } else {
        this.$router.push({ path: '/login' })
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .phoneShow{
    display: none;
  }
    .titlename {
        color: #333333;
        font-size: 14px;
        font-weight: 500;
        display: inline-block;
        padding-top: 8px;
        height: 55px;
        line-height: 25px;
        width: 100%;

    }

    .libox {
        padding: 20px 0;
        margin-left: 20px;
        text-align: left;

        .leftBox {
            width: 215px;
            height: 143px;
            display: inline-block;
            vertical-align: top;
            position: relative;

            img {
                width: 100%;
                height: 143px;
                cursor: pointer;
            }

            .toptitle {
                display: inline-block;
                position: absolute;
                top: 11px;
                left: 10px;
                height: 18px;
                font-size: 12px;
                color: #ffffff;
                background-color: rgba(51, 51, 51, .5);
                padding: 0 5px;
                border-radius: 5px;
                cursor: pointer;
                z-index: 3;
                line-height: 18px;

                &:hover {
                    background-color: rgba(237, 64, 64, .5);
                }
            }
        }

        .rightBox {
            display: inline-block;
            width: 840px;
           overflow: hidden;
            vertical-align: top;
            .titles111 {
                min-height: 19px;
                max-height: 40px;
                width: 100%;
                display: inline-block;
                font-size: 12px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
                .zhiding {
                    height: 19px;
                    background-color: #ed4040;
                    width: 36px;
                    border-radius: 9px;
                    color: #ffffff;
                    display: inline-block;
                    text-align: center;
                    line-height: 19px;
                    margin-right: 10px;
                }

                .title {
                    color: #333333;
                    font-size: 14px;
                    height: 19px;
                    line-height: 19px;
                    font-weight: 600;
                    cursor: pointer;
                }
            }

            .contentbox {
                color: #666666;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                margin: 12px 0;
            }

            .contentbox_no {
                width: 100%;
                font-size: 18px;
                color: #dbdbdb;
                font-weight: 700;
                height: 20px;
                display: inline-block;
                overflow: hidden;
                margin: 3px 0;
            }

            .foot_content {
                color: #b2b2b2;
                padding-top: 8px;
                .types {
                    display: inline-block;
                    width: 40px;
                    height: 18px;
                    border: 1px solid #ed4040;
                    text-align: center;
                    line-height: 18px;
                    color: #ed4040;
                    border-radius: 3px;
                    font-size: 12px;
                }

                .column {
                    margin-left: 10px;
                    cursor: pointer;

                    &:hover {
                        color: #ed4040;
                    }
                }

                .times {
                    margin-left: 20px;
                  font-size: 14px;
                }

                .readSize {
                    display: inline-block;
                    width: 80px;
                    margin-left: 419px;
                    text-align: right;
                }

                .collectionSize {
                    width: 80px;
                    display: inline-block;
                    cursor: pointer;
                    text-align: right;

                    &:hover {
                        color: #ed4040;
                    }
                }

                .speckSize {
                    display: inline-block;
                    width: 80px;
                  text-align: right;
                }
            }
        }
    }

    .left1 {
        width: 100%;
        height: 140px;
        background-color: #f5f5f5;
        display: inline-block;
        text-align: center;
        cursor: pointer;

        svg {
            width: 60px;
            height: 80px;
            color: #cbe8fa;
            margin-top: 35px;
        }

    }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
      .phoneShow{
        display: block;
        width: 100%;
        height: 100%;
        background-color: transparent;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
      }
        .libox {
            padding: 10px 20px;
            overflow: hidden;
            margin-left: 0;
           position: relative;
            .leftBox {
              float: right;
              height: 150px;
              width: 30%;
              overflow: hidden;
              .toptitle{
                display: none;
              }
                img {
                  height: 150px;
                  width: auto;
                }
            }

            .rightBox {
              float: left;
              max-height: 150px;
              width: 100%;
              overflow: hidden;
              padding: 0;
                .contentbox_no {
                  overflow: hidden;
                  margin: 0;
                  height: 0;
                }

                .foot_content {
                    position: relative;
                    padding: 0;
                    .times {
                      font-size: 12px;
                      margin-left: 5px;
                    }
                    .readSize, .collectionSize, .speckSize {
                      font-size: 12px;
                      text-align: right;
                      width: 60px;
                      margin-left: 0;
                    }
                    .readSize {
                    margin-left: 5px;
                    }

                    .collectionSize {

                    }

                    .speckSize {

                    }
                }
            }
        }
    }
</style>
